import { render, staticRenderFns } from "./keynote.vue?vue&type=template&id=be5b13c2&"
import script from "./keynote.vue?vue&type=script&lang=js&"
export * from "./keynote.vue?vue&type=script&lang=js&"
import style0 from "./keynote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports